import { render, staticRenderFns } from "./PackageTable.vue?vue&type=template&id=1a89316e&scoped=true&"
import script from "./PackageTable.vue?vue&type=script&lang=ts&"
export * from "./PackageTable.vue?vue&type=script&lang=ts&"
import style0 from "./PackageTable.vue?vue&type=style&index=0&id=1a89316e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89316e",
  null
  
)

export default component.exports